import styled from "styled-components";

export const FactsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 0 0 0;  
  flex: 1;
  min-height: 0;
  overflow: hidden;
  
`;

export const UserCellContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const UserAvatarContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const UserTextContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FactNameLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;

